"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var userRouter = {
  path: '/member',
  component: _layout.default,
  redirect: '/member/overview',
  name: 'Member',
  meta: {
    title: '会员',
    icon: 'clipboard'
  },
  children: [{
    path: 'overview',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/overview'));
      });
    },
    name: 'Overview',
    meta: {
      title: '会员概览',
      icon: ''
    }
  }, {
    path: 'user',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/user'));
      });
    },
    name: 'User',
    meta: {
      title: '用户列表',
      icon: ''
    }
  }, {
    path: 'shoppingCredit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/shoppingCredit'));
      });
    },
    name: 'ShoppingCredit',
    meta: {
      title: '购物金',
      icon: ''
    },
    children: [{
      path: 'order',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/member/shoppingCredit/order'));
        });
      },
      name: 'CreditOrder',
      meta: {
        title: '充值订单',
        icon: ''
      }
    }, {
      path: 'settings',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/member/shoppingCredit/settings'));
        });
      },
      name: 'Settings',
      meta: {
        title: '充值套餐',
        icon: ''
      }
    }, {
      path: 'refund',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/member/shoppingCredit/refund'));
        });
      },
      name: 'Refund',
      meta: {
        title: '充值退款',
        icon: ''
      }
    }]
  }, {
    path: 'level',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/level'));
      });
    },
    name: 'Level',
    meta: {
      title: '会员等级',
      icon: ''
    }
  }, {
    path: 'benefit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/benefit'));
      });
    },
    name: 'Benefit',
    meta: {
      title: '会员权益',
      icon: ''
    }
  }, {
    path: 'agreement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/agreement'));
      });
    },
    name: 'Agreement',
    meta: {
      title: '会员协议',
      icon: ''
    }
  }]
};
var _default = exports.default = userRouter;